<template>
  <div class="foodmenu-container" v-if="filtredMenu.groups.length">
      <div class="group-container" v-for="(group, gpkey) in filtredMenu.groups" :key="gpkey" :id="`group-${gpkey}`">
        <span class="title" @click="toggleGroup(gpkey)">
          <div class="title-name"> {{ group.groupName }}</div>
          <fa :icon="['fas', 'chevron-down']" class="title-icon" :class="{ 'is-collapsed': !isGroupExpanded(gpkey) }"/>
        </span>

        <template v-if="isGroupExpanded(gpkey)">
          <div class="products-item-container" v-for="(prod, prodKey) in (group.products.length ? group.products : group.subGroups.map(sbp=> sbp.products)[0])" :key="`${gpkey}${prodKey}`" @click="$emit('productClicked', prod)">
            <div class="prod-details">
                  <span class="prodName" v-text="prod.productName"></span>
                  <span class="prodDesc" v-text="prod.productDescription"></span>
                  <!-- <span class="prodPrice">
                    {{ formatPrice(getMinPriceTxt(prod) || prod.price) }}
                  </span> -->
                  <span class="prodPrice">
                    <template v-if="getPriceDisplay(prod).hasDiscount">
                      <span style="text-decoration: line-through; color: gray; font-size: 14px;">
                        {{ getPriceDisplay(prod).fullPriceFormatted }}
                      </span>
                      <span> por {{ getPriceDisplay(prod).priceFormatted }}</span>
                    </template>
                    <template v-else>
                      {{ getPriceDisplay(prod).priceFormatted }}
                    </template>
                  </span>
              </div>
              <img :src="prod.productImages.small || getMockImage(prod) || require('@/assets/mock/prodImg/placeholder.svg')" alt="Product Image" />
          </div>
        </template>
    </div>
    <div style="height: 100px;"></div>
  </div>

  <div v-else class="not-found">
    <p>Nenhum resultado encontrado <span v-if="searchText">para "{{ searchText }}"</span>.</p>
  </div>
</template>

<script>
import MinPriceController from '@/assets/controllers/MinPriceController'
import eventModule from '@/assets/libs/eventModule'
import { mapGetters } from 'vuex'

export default {
  name: 'FoodMenu',
  data () {
    return {
      searchText: '',
      groupVisibility: {}
    }
  },
  props: ['search'],
  computed: {
    ...mapGetters(['getMenu', 'getCardapio']),
    filtredMenu () {
      // Se houver search, retorna os filtrados
      if (!this.filteredBySearch.groups.length) {
        this.$emit('found', false)
      }
      if (this.searchText) return this.filteredBySearch
      return this.getMenu
    },
    filteredBySearch () {
      const normalize = (str) => (str || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      const matchText = (target, textToTest) => {
        return normalize(textToTest).toLowerCase().includes(normalize(target).toLowerCase())
      }
      const matchProduct = (prod) => {
        return matchText(this.searchText, prod.productName) || matchText(this.searchText, prod.productDescription)
      }

      const filtredGroups = []
      if (this.getMenu?.groups) {
        this.getMenu.groups.forEach(group => {
          const groupClone = JSON.parse(JSON.stringify(group))
          let hasSubGroupProds = false
          groupClone.products = groupClone.products.filter(matchProduct)
          if (Array.isArray(groupClone.subGroups)) {
            groupClone.subGroups = groupClone.subGroups.filter(subGroup => {
              subGroup.products = subGroup.products.filter(matchProduct)
              const hasProducts = subGroup.products.length > 0
              hasSubGroupProds = hasSubGroupProds || hasProducts
              return hasProducts
            })
          }
          if (groupClone.products.length || hasSubGroupProds) {
            filtredGroups.push(groupClone)
          }
        })
      }
      if (filtredGroups.length) {
        this.$emit('found', true)
      }
      return { groups: filtredGroups }
    }
  },
  methods: {
    getMockImage (prod) {
      try {
        return require(`@/assets/mock/prodImg/${prod.productCode}.png`)
      } catch (error) {
        return null
      }
    },
    getMinPriceTxt (prod) {
      const price = MinPriceController.getMinPrice(prod)
      return price
    },
    formatPrice (price) {
      return (new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(price))
    },
    getPriceDisplay (prod) {
      const minPrice = this.getMinPriceTxt(prod) || prod.price
      const fullPrice = prod.fullPrice

      if (fullPrice && minPrice !== fullPrice && parseFloat(minPrice) < parseFloat(fullPrice)) {
        return {
          hasDiscount: true,
          fullPriceFormatted: this.formatPrice(fullPrice),
          priceFormatted: this.formatPrice(minPrice)
        }
      }

      return {
        hasDiscount: false,
        priceFormatted: this.formatPrice(minPrice)
      }
    },
    searchInMenu (searchText) {
      this.searchText = typeof searchText === 'string' ? searchText : (searchText?.text || '')
      eventModule.emit('scrollChange')
    },
    toggleGroup (gpkey) {
      this.groupVisibility[gpkey] = !this.groupVisibility[gpkey]
      eventModule.emit('scrollChange')
    },
    isGroupExpanded (gpkey) {
      return this.groupVisibility[gpkey] !== false
    }
  },
  mounted () {
    eventModule.on('searchInMenu', this.searchInMenu)
  },
  beforeUnmount () {
    eventModule.off('searchInMenu', this.searchInMenu)
  },
  watch: {
    filtredMenu: {
      handler (newMenu) {
        if (newMenu && newMenu.groups) {
          newMenu.groups.forEach((group, gpkey) => {
            if (this.groupVisibility[gpkey] === undefined) {
              this.groupVisibility[gpkey] = true
            }
          })
        }
      },
      immediate: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.foodmenu-container {
    .group-container {
      scroll-margin-top: 100px;
    }

    .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 20px;
        font-weight: bold;
        font-size: 20px;
        color: var(--primaryColor);
        background-color: var(--primaryColorTransparent);
    }

    .title-icon {
      transition: transform 0.3s ease;
    }

    .title-icon.is-collapsed {
      transform: rotate(-90deg);
    }
    .products-item-container {
        position: relative;
        padding: 10px 50px 10px 20px;
        display: grid;
        grid-template-columns: calc(100% - 140px) 120px;
        grid-column-gap: 20px;
        margin-bottom: 10px;
        &:after{
            content: '';
            position: absolute;
            bottom: 0;
            left: 20px;
            right: 20px;
            height: 1px;
            background: #717171;
            opacity: 0.2;
            border-radius: 100%;
        }

        &:last-child:after {
            display: none;
        }

        .prod-details {
            .prodDesc {
                font-size: 14px;
                color: #717171;
                overflow: hidden;
                text-overflow: ellipsis;
                -webkit-box-orient: vertical;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                margin: 20px 0;
            }
            .prodPrice {
                margin-top: 20px;
                font-weight: bold;
            }
        }
        img {
            position: relative;
            height: 100px;
            width: 150px;
            display: block;
            object-fit: cover;
        }
    }

}

.not-found {
  text-align: center;
  padding: 20px;
  color: #717171;
}
</style>
